import React, { useEffect, useState, Children, createElement } from 'react';
import { motion } from 'framer-motion';
import { Moon, Clock, CheckCircle, Zap, Shield, ArrowDown, Star, Download, AlertCircle, Heart } from 'lucide-react';
// Animation variants
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
const staggerContainer = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
    _fbq: unknown;
  }
}
export function SalesPage() {
  const [modal, setModal] = useState<'privacy' | 'terms' | null>(null);
  // Inject Meta Pixel & fire PageView on mount
  useEffect(() => {
    // Set up the fbq stub queue synchronously (official Meta pattern)
    if (!window.fbq) {
      const fbq = function (...args: unknown[]) {
        if ((fbq as any).callMethod) {
          ;
          (fbq as any).callMethod.apply(fbq, args);
        } else {
          ;
          (fbq as any).queue.push(args);
        }
      } as any;
      if (!window._fbq) window._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      window.fbq = fbq;
    }
    // Now safe to call init and PageView immediately
    window.fbq('init', '1451207993016055');
    window.fbq('track', 'PageView');
    // Load the fbevents.js script asynchronously
    if (!document.querySelector('script[src*="fbevents.js"]')) {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      // Noscript fallback
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = 'https://www.facebook.com/tr?id=1451207993016055&ev=PageView&noscript=1';
      noscript.appendChild(img);
      document.head.appendChild(noscript);
    }
  }, []);
  // Fire AddToCart event then navigate
  const handleAddToCart = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const url = 'https://www.calmin3x3.com/cart/53935647752476:1';
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'AddToCart', {
        value: 6.39,
        currency: 'USD',
        content_name: 'The 72-Hour Reset',
        content_type: 'product'
      });
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  return <div className="min-h-screen bg-cream font-sans text-slate-800 overflow-x-hidden" data-id="element-2">
      {/* MODAL */}
      {modal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-navy-dark/80 backdrop-blur-sm" onClick={() => setModal(null)} data-id="element-3">
          <div className="bg-cream rounded-2xl shadow-2xl max-w-lg w-full max-h-[80vh] overflow-y-auto p-8 relative" onClick={e => e.stopPropagation()} data-id="element-4">
            <button onClick={() => setModal(null)} className="absolute top-4 right-4 text-slate-400 hover:text-slate-700 transition-colors text-2xl leading-none" aria-label="Close" data-id="element-5">
              ×
            </button>

            {modal === 'privacy' && <>
                <h2 className="font-serif text-2xl text-navy mb-4" data-id="element-6">
                  Privacy Policy
                </h2>
                <div className="space-y-4 text-sm text-slate-600 leading-relaxed" data-id="element-7">
                  <p data-id="element-8">
                    <strong data-id="element-9">Last updated:</strong> {new Date().getFullYear()}
                  </p>
                  <p data-id="element-10">
                    The 72-Hour Reset ("we", "us") is committed to protecting
                    your privacy. This policy explains how we collect and use
                    your information.
                  </p>
                  <h3 className="font-semibold text-slate-800 mt-4" data-id="element-11">
                    Information We Collect
                  </h3>
                  <p data-id="element-12">
                    We collect only the information necessary to process your
                    purchase (name, email, payment details). Payment information
                    is processed securely by our payment provider and is never
                    stored on our servers.
                  </p>
                  <h3 className="font-semibold text-slate-800 mt-4" data-id="element-13">
                    How We Use Your Information
                  </h3>
                  <p data-id="element-14">
                    Your email is used solely to deliver your digital download
                    and, if you opt in, to send related educational content. We
                    do not sell or share your personal information with third
                    parties.
                  </p>
                  <h3 className="font-semibold text-slate-800 mt-4" data-id="element-15">Cookies</h3>
                  <p data-id="element-16">
                    We use minimal cookies necessary for the checkout process.
                    We do not use tracking cookies for advertising purposes.
                  </p>
                  <h3 className="font-semibold text-slate-800 mt-4" data-id="element-17">
                    Your Rights
                  </h3>
                  <p data-id="element-18">
                    You may request deletion of your personal data at any time
                    by emailing us. We will comply within 30 days.
                  </p>
                </div>
              </>}

            {modal === 'terms' && <>
                <h2 className="font-serif text-2xl text-navy mb-4" data-id="element-19">
                  Terms of Service
                </h2>
                <div className="space-y-4 text-sm text-slate-600 leading-relaxed" data-id="element-20">
                  <p data-id="element-21">
                    <strong data-id="element-22">Last updated:</strong> {new Date().getFullYear()}
                  </p>
                  <p data-id="element-23">
                    By purchasing The 72-Hour Reset, you agree to the following
                    terms.
                  </p>
                  <h3 className="font-semibold text-slate-800 mt-4" data-id="element-24">
                    Digital Product
                  </h3>
                  <p data-id="element-25">
                    This is a digital download. Upon purchase, you will receive
                    immediate access to the PDF guide. No physical product will
                    be shipped.
                  </p>
                  <h3 className="font-semibold text-slate-800 mt-4" data-id="element-26">
                    Personal Use Only
                  </h3>
                  <p data-id="element-27">
                    This guide is licensed for personal use only. You may not
                    reproduce, distribute, resell, or share the content without
                    written permission.
                  </p>
                  <h3 className="font-semibold text-slate-800 mt-4" data-id="element-28">
                    Refund Policy
                  </h3>
                  <p data-id="element-29">
                    We offer a 30-day money-back guarantee. If you are not
                    satisfied with your purchase, contact us within 30 days for
                    a full refund, no questions asked.
                  </p>
                  <h3 className="font-semibold text-slate-800 mt-4" data-id="element-30">
                    Medical Disclaimer
                  </h3>
                  <p data-id="element-31">
                    The information in this guide is for educational purposes
                    only and does not constitute medical advice. Always consult
                    your pediatrician before making changes to your baby's sleep
                    routine.
                  </p>
                  <h3 className="font-semibold text-slate-800 mt-4" data-id="element-32">
                    Results Disclaimer
                  </h3>
                  <p data-id="element-33">
                    Individual results may vary. The outcomes described are
                    based on typical experiences and are not guaranteed.
                  </p>
                </div>
              </>}

            <button onClick={() => setModal(null)} className="mt-6 w-full bg-navy text-white font-medium py-3 rounded-xl hover:bg-navy-light transition-colors" data-id="element-34">
              Close
            </button>
          </div>
        </div>}

      {/* SECTION 1: HERO */}
      <header className="relative bg-navy text-white pt-12 pb-20 md:pt-20 md:pb-32 overflow-hidden" data-id="element-35">
        {/* Abstract Background Elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-20 pointer-events-none" data-id="element-36">
          <div className="absolute top-[-10%] right-[-5%] w-[500px] h-[500px] rounded-full bg-navy-light blur-3xl" data-id="element-37"></div>
          <div className="absolute bottom-[-10%] left-[-10%] w-[600px] h-[600px] rounded-full bg-navy-dark blur-3xl" data-id="element-38"></div>
        </div>

        <div className="container mx-auto px-6 relative z-10" data-id="element-39">
          <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-40">
            {/* Hero Copy */}
            <motion.div className="lg:w-1/2 text-center lg:text-left" initial="hidden" animate="visible" variants={staggerContainer} data-id="element-41">
              <motion.div variants={fadeIn} className="inline-block mb-6" data-id="element-42">
                <span className="text-gold font-bold tracking-[0.2em] text-xs md:text-sm uppercase border border-gold/30 px-4 py-2 rounded-full bg-navy-dark/50 backdrop-blur-sm" data-id="element-43">
                  For Moms of 6–12 Month Olds
                </span>
              </motion.div>

              <motion.h1 variants={fadeIn} className="font-serif text-4xl md:text-5xl lg:text-6xl leading-tight mb-6" data-id="element-44">
                The <span className="text-gold italic" data-id="element-45">"Good Sleeper"</span>{' '}
                Betrayal
              </motion.h1>

              <motion.p variants={fadeIn} className="text-lg md:text-xl text-cream-warm/90 mb-8 leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-46">
                Why your 8-month-old suddenly stopped sleeping (and how to fix
                it in 72 hours without "Cry It Out").
              </motion.p>

              <motion.div variants={fadeIn} className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-47">
                <a href="#offer" className="bg-gold hover:bg-gold-light text-navy-dark font-bold py-4 px-8 rounded-lg shadow-lg shadow-gold/20 transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2 text-lg" data-id="element-48">
                  <Download className="w-5 h-5" data-id="element-49" />
                  Get The 72-Hour Reset
                </a>
                <a href="#read-more" className="bg-transparent border border-white/20 hover:bg-white/5 text-white font-medium py-4 px-8 rounded-lg transition-colors flex items-center justify-center gap-2" data-id="element-50">
                  Read the Story
                  <ArrowDown className="w-4 h-4" data-id="element-51" />
                </a>
              </motion.div>

              <motion.div variants={fadeIn} className="mt-8 flex items-center justify-center lg:justify-start gap-2 text-sm text-cream-warm/60" data-id="element-52">
                <div className="flex -space-x-2" data-id="element-53">
                  {[1, 2, 3, 4].map(i => <div key={i} className="w-8 h-8 rounded-full bg-cream-dark border-2 border-navy flex items-center justify-center text-navy-dark font-bold text-xs overflow-hidden" data-id="element-54">
                      <img src={`https://api.dicebear.com/7.x/avataaars/svg?seed=${i * 123}&backgroundColor=e5e7eb`} alt="User" data-id="element-55" />
                    </div>)}
                </div>
                <p data-id="element-56">Trusted by 2,400+ moms this month</p>
              </motion.div>
            </motion.div>

            {/* Hero Image */}
            <motion.div className="lg:w-1/2" initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.8,
            delay: 0.4
          }} data-id="element-57">
              <div className="relative" data-id="element-58">
                <div className="absolute inset-0 bg-gold/20 blur-[60px] rounded-full transform scale-75" data-id="element-59"></div>
                <img src="https://cdn.magicpatterns.com/uploads/sYViU3qwmR5pDXju4eQef5/heylloyd-image-1771527226289.png" alt="The 72-Hour Reset Guide on a tablet" className="relative z-10 w-full max-w-md mx-auto drop-shadow-2xl transform rotate-[-2deg] hover:rotate-0 transition-transform duration-500" data-id="element-60" />
              </div>
            </motion.div>
          </div>
        </div>

        {/* Wave Divider */}
        <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none" data-id="element-61">
          <svg className="relative block w-full h-[60px] text-cream" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-62">
            <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="currentColor" data-id="element-63"></path>
          </svg>
        </div>
      </header>

      {/* SECTION 2: THE LEAD (STORY) */}
      <section id="read-more" className="py-20 px-6" data-id="element-64">
        <div className="max-w-3xl mx-auto" data-id="element-65">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} variants={staggerContainer} className="prose prose-lg prose-slate mx-auto" data-id="element-66">
            <motion.p variants={fadeIn} className="font-serif text-2xl md:text-3xl text-navy font-medium italic leading-relaxed mb-8 border-l-4 border-gold pl-6" data-id="element-67">
              "You thought the worst was over. You survived the newborn haze.
              You finally had a routine. And then, it happened."
            </motion.p>

            <motion.div variants={fadeIn} className="space-y-6 text-slate-700 leading-relaxed" data-id="element-68">
              <p data-id="element-69">
                You were starting to feel like <strong data-id="element-70">you</strong> again. Maybe
                you even booked a hair appointment or had a date night.
              </p>
              <p data-id="element-71">
                But somewhere between 7 and 9 months, the{' '}
                <strong data-id="element-72">"Second Wave"</strong> hit.
              </p>
              <p data-id="element-73">
                Now, instead of a sleeping baby, you have a tiny human standing
                in their crib at 2:14 AM, screaming with the intensity of a
                thousand suns. They aren't hungry. They don't need a diaper.
                They are just... <em data-id="element-74">awake.</em>
              </p>
              <p data-id="element-75">
                And they won't go back down unless you rock them, nurse them, or
                pace the hallway for forty-five minutes.
              </p>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* SECTION 3: THE PROBLEM */}
      <section className="py-20 bg-cream-dark border-y border-cream-warm/50" data-id="element-76">
        <div className="container mx-auto px-6" data-id="element-77">
          <motion.div className="max-w-4xl mx-auto" initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={staggerContainer} data-id="element-78">
            <motion.div variants={fadeIn} className="text-center mb-16" data-id="element-79">
              <span className="text-navy font-bold tracking-widest uppercase text-sm mb-2 block" data-id="element-80">
                The Real Issue
              </span>
              <h2 className="font-serif text-3xl md:text-4xl text-navy-dark mb-6" data-id="element-81">
                Why Old Solutions Are Failing You
              </h2>
              <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-82"></div>
            </motion.div>

            <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-83">
              <motion.div variants={fadeIn} className="space-y-6" data-id="element-84">
                <p className="text-lg text-slate-700" data-id="element-85">
                  You've tried the apps. You've tried "Wake Windows." You've
                  tried "Gentle Sleep Training."
                </p>
                <p className="text-lg text-slate-700 font-medium" data-id="element-86">
                  The problem? Most advice is written for newborns.
                </p>
                <p className="text-lg text-slate-700" data-id="element-87">
                  But your baby isn't a newborn anymore. They are a{' '}
                  <strong data-id="element-88">Developmental Powerhouse.</strong>
                </p>
                <ul className="space-y-4 mt-4" data-id="element-89">
                  {['Their brain is exploding with new skills', 'They are practicing crawling/standing in their sleep', 'Their metabolic needs have shifted completely'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-90">
                      <AlertCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-0.5" data-id="element-91" />
                      <span className="text-slate-700" data-id="element-92">{item}</span>
                    </li>)}
                </ul>
              </motion.div>

              <motion.div variants={fadeIn} className="bg-white p-8 rounded-2xl shadow-xl border border-cream-warm relative overflow-hidden" data-id="element-93">
                <div className="absolute top-0 right-0 w-32 h-32 bg-gold/10 rounded-bl-full -mr-10 -mt-10" data-id="element-94"></div>
                <h3 className="font-serif text-2xl text-navy mb-4" data-id="element-95">
                  The "Battery" Mistake
                </h3>
                <p className="text-slate-600 mb-6" data-id="element-96">
                  Most moms think their baby is "overtired." But at 8-10 months,
                  the opposite is often true. Their "sleep pressure" battery
                  isn't draining fast enough because of the{' '}
                  <strong data-id="element-97">Biological Window Sync</strong> failure.
                </p>
                <div className="bg-navy/5 p-4 rounded-lg border-l-4 border-navy" data-id="element-98">
                  <p className="text-navy-dark font-medium italic" data-id="element-99">
                    "You don't need a schedule. You need a Biological Reset."
                  </p>
                </div>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* SECTION 4: THE SOLUTION */}
      <section className="py-24 bg-navy text-white relative overflow-hidden" data-id="element-100">
        {/* Background texture */}
        <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: 'radial-gradient(#C9A84C 1px, transparent 1px)',
        backgroundSize: '30px 30px'
      }} data-id="element-101"></div>

        <div className="container mx-auto px-6 relative z-10" data-id="element-102">
          <motion.div className="max-w-4xl mx-auto text-center" initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={staggerContainer} data-id="element-103">
            <motion.div variants={fadeIn} className="inline-block mb-6" data-id="element-104">
              <div className="flex items-center gap-2 text-gold font-bold tracking-widest uppercase text-sm border border-gold/30 px-4 py-1 rounded-full" data-id="element-105">
                <Star className="w-4 h-4 fill-gold" data-id="element-106" />
                <span data-id="element-107">The Solution</span>
                <Star className="w-4 h-4 fill-gold" data-id="element-108" />
              </div>
            </motion.div>

            <motion.h2 variants={fadeIn} className="font-serif text-4xl md:text-5xl lg:text-6xl mb-6" data-id="element-109">
              Introducing: <span className="text-gold" data-id="element-110">The 72-Hour Reset</span>
            </motion.h2>

            <motion.p variants={fadeIn} className="text-xl md:text-2xl text-cream-warm/80 mb-12 max-w-2xl mx-auto" data-id="element-111">
              The 8-10 Month Regression Killer. Not a 200-page book of fluff. A
              tactical, hour-by-hour intervention.
            </motion.p>
          </motion.div>

          {/* Feature Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mt-12" data-id="element-112">
            {[{
            icon: Clock,
            title: 'Biological Window Sync',
            desc: "Force your baby's body to crave deep sleep the second the sun goes down."
          }, {
            icon: ArrowDown,
            title: "The 'Crib-Standing' Fix",
            desc: "Exactly what to do when they pull up and can't get down (without becoming a Jack-in-the-Box)."
          }, {
            icon: Zap,
            title: 'Metabolic Loading',
            desc: "Stack daytime calories so their brain ignores 'habitual hunger' at 3 AM."
          }, {
            icon: Shield,
            title: '72-Hour Battle Plan',
            desc: 'A specific Friday-to-Monday schedule to get your life back.'
          }].map((feature, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1 + 0.3,
            duration: 0.5
          }} className="bg-navy-dark/50 backdrop-blur-sm border border-white/10 p-6 rounded-xl hover:border-gold/50 transition-colors group" data-id="element-113">
                <div className="w-12 h-12 bg-navy rounded-full flex items-center justify-center mb-4 group-hover:bg-gold transition-colors" data-id="element-114">
                  <feature.icon className="w-6 h-6 text-gold group-hover:text-navy-dark" data-id="element-115" />
                </div>
                <h3 className="font-serif text-xl text-white mb-3" data-id="element-116">
                  {feature.title}
                </h3>
                <p className="text-cream-warm/70 text-sm leading-relaxed" data-id="element-117">
                  {feature.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* SECTION 5: THE RESULT */}
      <section className="py-20 px-6 bg-cream" data-id="element-118">
        <div className="max-w-4xl mx-auto" data-id="element-119">
          <motion.div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12 border border-cream-warm/50 flex flex-col md:flex-row items-center gap-10" initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} data-id="element-120">
            <div className="md:w-1/2" data-id="element-121">
              <img src="https://images.unsplash.com/photo-1519689680058-324335c77eba?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Peaceful sleeping baby" className="rounded-2xl shadow-lg w-full h-64 object-cover" data-id="element-122" />
            </div>
            <div className="md:w-1/2" data-id="element-123">
              <h3 className="font-serif text-3xl text-navy mb-4" data-id="element-124">
                The Monday Morning Vision
              </h3>
              <p className="text-slate-600 mb-6 leading-relaxed" data-id="element-125">
                By Monday morning, you aren't just a "Mom." You are a
                well-rested woman with a full cup of coffee and a baby who
                sleeps till 7 AM.
              </p>
              <ul className="space-y-3 mb-8" data-id="element-126">
                {['Reclaim your evenings', 'Reclaim your bed', 'Reclaim your sanity'].map((item, i) => <li key={i} className="flex items-center gap-3 text-navy font-medium" data-id="element-127">
                    <CheckCircle className="w-5 h-5 text-gold" data-id="element-128" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </motion.div>
        </div>
      </section>

      {/* SECTION 6: OFFER & CTA */}
      <section id="offer" className="py-24 bg-navy-dark text-white relative overflow-hidden" data-id="element-129">
        <div className="absolute top-0 left-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-10" data-id="element-130"></div>

        <div className="container mx-auto px-6 relative z-10" data-id="element-131">
          <motion.div className="max-w-3xl mx-auto text-center" initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={staggerContainer} data-id="element-132">
            <motion.h2 variants={fadeIn} className="font-serif text-4xl md:text-5xl mb-4" data-id="element-133">
              Get The 72-Hour Reset Now
            </motion.h2>
            <motion.p variants={fadeIn} className="text-xl text-cream-warm/60 mb-12" data-id="element-134">
              Instant Digital Download • Secure Checkout
            </motion.p>

            <motion.div variants={fadeIn} className="bg-white text-slate-800 rounded-2xl p-8 md:p-10 shadow-2xl max-w-lg mx-auto relative" data-id="element-135">
              {/* Badge */}
              <div className="absolute -top-6 -right-6 bg-gold text-navy-dark font-bold w-24 h-24 rounded-full flex flex-col items-center justify-center shadow-lg transform rotate-12" data-id="element-136">
                <span className="text-xs uppercase tracking-wide" data-id="element-137">Only</span>
                <span className="text-2xl font-serif" data-id="element-138">$6.39</span>
              </div>

              <div className="text-left mb-8" data-id="element-139">
                <h3 className="font-serif text-2xl text-navy mb-2" data-id="element-140">
                  What's Included:
                </h3>
                <div className="w-full h-px bg-slate-200 my-4" data-id="element-141"></div>
                <ul className="space-y-4" data-id="element-142">
                  <li className="flex items-start gap-3" data-id="element-143">
                    <CheckCircle className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" data-id="element-144" />
                    <span data-id="element-145">
                      <strong data-id="element-146">The 72-Hour Protocol</strong> (PDF Guide)
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-147">
                    <CheckCircle className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" data-id="element-148" />
                    <span data-id="element-149">
                      <strong data-id="element-150">The "Crib-Standing" Cheat Sheet</strong>
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-151">
                    <CheckCircle className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" data-id="element-152" />
                    <span data-id="element-153">
                      <strong data-id="element-154">Daytime Calorie Stacking Menu</strong>
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-155">
                    <CheckCircle className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" data-id="element-156" />
                    <span data-id="element-157">
                      <strong data-id="element-158">Bonus:</strong> The "Teething vs. Habit" Checklist
                    </span>
                  </li>
                </ul>
              </div>

              <a href="https://www.calmin3x3.com/cart/53935647752476:1" target="_blank" rel="noopener noreferrer" onClick={handleAddToCart} className="w-full bg-gold hover:bg-gold-light text-navy-dark font-bold text-xl py-5 px-8 rounded-xl shadow-lg shadow-gold/30 transition-all transform hover:-translate-y-1 flex items-center justify-center gap-3" data-id="element-159">
                <Download className="w-6 h-6" data-id="element-160" />
                <span className="flex flex-col items-center leading-tight" data-id="element-161">
                  <span data-id="element-162">Download Instantly for $6.39</span>
                  <span className="text-sm font-normal line-through opacity-60" data-id="element-163">
                    Regular price $27
                  </span>
                </span>
              </a>

              <p className="mt-4 text-xs text-slate-400 text-center" data-id="element-164">
                100% Money-Back Guarantee. If you don't see improvement in 3
                nights, we'll refund you.
              </p>
            </motion.div>

            <motion.div variants={fadeIn} className="mt-16 flex flex-col md:flex-row items-center justify-center gap-8 opacity-60" data-id="element-165">
              <div className="flex items-center gap-2" data-id="element-166">
                <Shield className="w-5 h-5" data-id="element-167" />
                <span className="text-sm" data-id="element-168">Secure 256-bit Encryption</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-169">
                <Heart className="w-5 h-5" data-id="element-170" />
                <span className="text-sm" data-id="element-171">Loved by 10,000+ Moms</span>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-navy-dark py-10 text-center text-sm" data-id="element-172">
        <div className="container mx-auto px-6" data-id="element-173">
          <p className="text-white/30" data-id="element-174">
            &copy; {new Date().getFullYear()} The 72-Hour Reset. All rights
            reserved.
          </p>
          <p className="text-white/20 mt-1 text-xs" data-id="element-175">
            Medical Disclaimer: This guide is for educational purposes only.
          </p>
          <div className="mt-4 flex items-center justify-center gap-6" data-id="element-176">
            <button onClick={() => setModal('privacy')} className="text-white/40 hover:text-gold text-xs transition-colors underline underline-offset-2" data-id="element-177">
              Privacy Policy
            </button>
            <span className="text-white/20" data-id="element-178">·</span>
            <button onClick={() => setModal('terms')} className="text-white/40 hover:text-gold text-xs transition-colors underline underline-offset-2" data-id="element-179">
              Terms of Service
            </button>
          </div>
        </div>
      </footer>
    </div>;
}